import { toPairs } from "lodash";
import { useEffect, useState } from "react";
import { singletonHook } from "react-singleton-hook";
import axios from "../general/HttpClient";

const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const CONTEXT_IDENTIFIER = "sca-context-identifier";
const PERMISSION_CLAIM = "sca-ide-permission";
const ORGANIZATION_MEMBERSHIP_CLAIM = "sca-organization-membership";

export interface Organization {
    id: string;
    name: string;
    scadsysOnlineSchoolID: string;
    defaultDomain: string;
    logoUri: string;
    shortCode: string;
}

export interface Claim {
    type: string;
    value: string;
}

export function GetOrganizationMemberships() {
    return account.claims.filter((c) => c.type == ORGANIZATION_MEMBERSHIP_CLAIM).map((c) => c.value);
}

export class Account {
    isAuthenticated: boolean;
    name: string;
    claims: Array<Claim>;
    organization: Organization;
    id: string;

    resolved: boolean;

    constructor(params?: { identity: any; organization: any }) {
        if (params) {
            let { identity, organization } = params;
            this.isAuthenticated = identity.isAuthenticated;
            this.name = identity.name;
            this.claims = identity.claims || [];
            this.organization = organization;
            this.id = (identity.claims || []).find((c) => c.type == "sub")?.value;
            this.resolved = true;
        }
    }

    hasRole(role) {
        return (this.claims || []).filter((c) => c.type == ROLE_CLAIM && c.value == role).length > 0;
    }

    hasPermission(permission, organization?) {
        if (!organization) {
            organization = this.organization?.id;
        }

        return (
            this.hasRole("Admin") ||
            (this.claims || [])
                .filter((c) => c.type == PERMISSION_CLAIM)
                .map((c) => c.value)
                .filter((c) => c == permission + ":" + organization).length > 0
        );
    }

    getClaim(claim) {
        let matched = this.claims.filter((c) => c.type == claim);
        if (matched.length > 0) {
            return matched[0].value;
        }
        return null;
    }
}

let account = new Account();

export function GetCurrentLogin(): Promise<Account> {
    return account.name
        ? new Promise((resolve) => {
              resolve(account);
          })
        : getUser();
}

function getUser() {
    return axios.get("/account/me").then((response) => {
        account = new Account(response?.data);
        return account;
    });
}

getUser();

const userFactory = () => {
    const [user, setUser] = useState(account);

    useEffect(() => {
        getUser().then((u) => {
            setUser(u);
        });
    }, []);

    return user;
};

export const useUser = singletonHook(account, userFactory);

export const usePermission = (permission) => {
    const user = useUser();
    return user.hasPermission(permission);
};
